module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/payment/payment.component.css
// module id = ./src/app/payment/payment.component.css
// module chunks = main